import React, { useEffect, useRef, useState } from 'react'
import Popup from '../../../components/popup/Popup'
import styles from "./RecommendForms.styles"
import Heading from '../../../components/heading/Heading'
import { HEADING } from '../../../components/heading/constants/constants'
import BasicCard from '../../../components/card/basiccard/BasicCard'
import Drawer from '../../../components/drawer/Drawer'
import selectYearFormTypeStyles from '../../formssection/createform/selectyearformtype/SelectYearFormType.styles'
import Icons from '../../../components/icons/Icons'
import { VEC_ICON_NAME } from '../../../components/icons/constants'
import Button from '../../../components/button/Button'
import { useDispatch, useSelector } from 'react-redux'
import General from '../../../../libs/utility/General'
import { addNotifications } from '../../toaster/ToasterPortalSlice'
import { TOASTER_VARIANT } from '../../../components/toast/constants'
import Loadable from '../../../components/loadable/Loadable'
import { getGuidedForms } from './RecommendFormSaga'
import { componentKey } from './RecommendFormSlice'
import { RECOMMEND_FORM_LOADING_STATES } from './Constants'

const RecommendForms = ({ formsList, userSelectedTaxYear, userSelectedForm, onCloseCb = () => { }, handleFormSelectCb, onClickFormFileCb }) => {
    const [selectedForm, setSelectedForm] = useState({})
    const [selectedQue, setSelectedQue] = useState({})

    const [showScrollDownButton, setShowScrollDownButton] = useState(true)
    const [isScrollAtBottom, setIsScrollAtBottom] = useState(false)

    const { guidedFormList, loadingState } = useSelector(state => state[componentKey])
    const dispatch = useDispatch()

    const cardsGroupContainerRef = useRef()

    useEffect(() => {
        dispatch(getGuidedForms())
    }, [])

    const handleScroll = () => {
        const scrollDiv = cardsGroupContainerRef.current;
        if (scrollDiv) {
            const { scrollTop, scrollHeight, clientHeight } = scrollDiv;
            if (scrollTop + clientHeight >= scrollHeight) {
                setIsScrollAtBottom(true)

            } else {
                setIsScrollAtBottom(false)
            }
        }
    };

    useEffect(() => {
        const scrollDiv = cardsGroupContainerRef.current;
        if (scrollDiv) {
            scrollDiv.addEventListener('scroll', handleScroll);

            return () => {
                scrollDiv.removeEventListener('scroll', handleScroll);
            };
        }
    }, [handleScroll, cardsGroupContainerRef.current]);

    useEffect(() => {
        if (isScrollAtBottom) {
            setShowScrollDownButton(false)
        } else {
            setShowScrollDownButton(true)
        }
    }, [isScrollAtBottom])

    const onClickFormQuery = (form) => {
        setSelectedQue(form)
        const selectedForm = formsList.Forms.find(f => f.Id === form.formid)
        setSelectedForm(selectedForm)
        handleFormSelectCb(selectedForm)
    }

    const onClickFormFile = () => {
        if (!userSelectedForm && !userSelectedTaxYear) {
            return
        }

        const availableForYear = userSelectedForm.Year.find(elm => elm === userSelectedTaxYear)

        if (availableForYear) {
            return onClickFormFileCb()
        } else {
            return dispatch(addNotifications({
                heading: "Error",
                message: `This Form is not valid for ${userSelectedTaxYear}`,
                variant: TOASTER_VARIANT.DANGER
            }))
        }
    }

    const RecommendFormComponent = (
        <>
            <div style={styles.container}>
                <div style={styles.heading}>
                    <Heading type={HEADING.H1}>Let's find the right form for you.</Heading>
                    <p>Select the one that applies, to get the best recommendation.</p>
                </div>

                <div style={styles.cardsGroupWrapper}>
                    <div style={styles.cardsGroupContainer} ref={cardsGroupContainerRef} className='recommend-cards-group-container'>
                        {guidedFormList?.length ? guidedFormList.map((form, idx) => (
                            <BasicCard
                                key={'form-question-' + idx}
                                customStyles={styles.basicCard}
                                isHighlighted={selectedForm.Id === form.formid}
                            >
                                <div
                                    onClick={() => {
                                        onClickFormQuery(form)
                                    }}
                                    style={styles.cardContent}>
                                    <span style={styles.cardLabel} dangerouslySetInnerHTML={{ __html: General.sanitizeContent(form?.question ?? '') }}></span>
                                </div>
                            </BasicCard>)
                        ) : null}
                    </div>
                    {showScrollDownButton && <div style={styles.scrollDownButton}
                        onClick={() => {
                            if (cardsGroupContainerRef.current) {
                                cardsGroupContainerRef.current.scrollTop = cardsGroupContainerRef.current.scrollHeight;
                                setIsScrollAtBottom(true)
                            }
                        }}
                    >
                        <Icons familyName={"vec"} color="#ffffff" iconName={VEC_ICON_NAME.CARET_DOWN} />
                    </div>}
                </div>
            </div>
        </>
    )

    const formRecommendationDrawer = (
        <>
            <div>
                <Drawer isOpen={true} customStyles={{ zIndex: "999", width: "35%" }} onCloseCb={onCloseCb} >
                    <div style={styles.drawerContent}>
                        <Icons familyName={"vec"} iconName={VEC_ICON_NAME.FORM_RECOMMEND_ICON} />
                        <Heading type={HEADING.H1} >{selectedForm.Id ? "Tax form recommendation engine" : "Please select the appropriate box that suits your requirement"}</Heading>
                        {selectedForm.Id && <>
                            <div style={selectYearFormTypeStyles.formBox}>
                                <Heading type={HEADING.H1} customStyle={selectYearFormTypeStyles.formNameStyles}>
                                    {selectedForm.FormLabel}
                                </Heading>
                                <Heading type={HEADING.H3} customStyle={selectYearFormTypeStyles.formBoxDesc}>
                                    {selectedForm.Desc}
                                </Heading>
                            </div>
                            <Heading type={HEADING.H3}>{selectedQue.suggestion}</Heading>
                            <div>
                                <Button onClickCb={onClickFormFile}>Click here to eFile</Button>
                            </div>
                        </>
                        }
                    </div>
                </Drawer>
            </div>
        </>
    )
    return (
        <Popup title={"Recommend 1099 form"} customPopupHeaderStyles={styles.customPopupHeaderStyles} isPopupOpen={true} customPopupSyles={styles.popupStyles} overlayStyles={styles.popupoOverlay} childrenStyles={styles.popupChildrenStyles}>
            <Loadable currentState={loadingState.state} loadingStates={[RECOMMEND_FORM_LOADING_STATES.GET_GUIDED_FORMS_LOADING]} isNewLoadable={true}>
                {RecommendFormComponent}
                {formRecommendationDrawer}
            </Loadable>
        </Popup >
    )
}

export default RecommendForms